import React, { FunctionComponent } from 'react';

import { connect, ConnectedProps, useSelector } from 'react-redux';

import { RootState } from '../../../../../init-store';
import { SELF } from '../../../../shared/constants';
import { setConferenceAccessLevel } from '../../../../shared/features/moderation/slice';
import { AccessLevel } from '../../../../types';
import { selectHasAccessLevelEditPermission } from '../../features/permissions';
import { getParticipant, selectIsPermissionsExtendedEnabled } from '../../selectors';
import AccessLevelControl from '../access-level-control';

const mapStateToProps = (state: RootState) => {
    const self = getParticipant(state, SELF);

    return {
        isModerator: Boolean(self.isModerator || self.isOwner),
    };
};

const mapDispatchToProps = {
    setConferenceAccessLevel,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type AccessLevelControlContainerProps = {
    className?: string;
    currentAccessLevel?: AccessLevel;
};
type AccessLevelControlContainerConnectedProps = ConnectedProps<typeof connector>;

const AccessLevelControlContainer: FunctionComponent<
    AccessLevelControlContainerConnectedProps & AccessLevelControlContainerProps
> = ({ className, isModerator, currentAccessLevel, setConferenceAccessLevel }) => {
    const hasAccessLevelEditPermission = useSelector(selectHasAccessLevelEditPermission);
    const isPermissionsExtendedEnabled = useSelector(selectIsPermissionsExtendedEnabled);

    const [shouldShowPopup, setShouldShowPopup] = React.useState(false);
    const closePopup = React.useCallback(() => {
        setShouldShowPopup(false);
    }, []);

    const onMainButtonClick = React.useCallback(() => {
        setShouldShowPopup((prevState) => !prevState);
    }, []);

    const handleAccessLevelChange = React.useCallback(
        (level: AccessLevel) => {
            setConferenceAccessLevel(level);
            closePopup();
        },
        [setConferenceAccessLevel, closePopup]
    );

    return (
        <AccessLevelControl
            className={className}
            isActive={isPermissionsExtendedEnabled ? hasAccessLevelEditPermission : isModerator}
            currentAccessLevel={currentAccessLevel}
            shouldShowPopup={shouldShowPopup}
            onClosePopup={closePopup}
            onMainButtonClick={onMainButtonClick}
            onAccessLevelChange={handleAccessLevelChange}
        />
    );
};

export default connector(AccessLevelControlContainer);
